import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Notice = styled(Typography.Label)`
  margin-top: 16px;
  display: inline-block;

  a {
    font-weight: inherit;
    font-size: inherit;
  }
`;

export const SelectWrapper = styled.div`
  max-width: 368px;
`;
